export default __webpack_public_path__ + "static/media/2019_1.f0dbb56f.jpg";